(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/shared-components/products/components/card-image-list.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/shared-components/products/components/card-image-list.js');
"use strict";


const ProductImageCard = svs.tickets_giftshop.products.components.ProductImageCard;
const CardImageList = _ref => {
  let {
    products = []
  } = _ref;
  const isValid = Array.isArray(products) && products.length > 0 && products.every(value => typeof value === 'object' && value.productImage && value.productId && value.productName);
  if (!isValid) return null;
  return products.map((product, i) => React.createElement(ProductImageCard, {
    image: product.productImage
    ,
    key: "product_".concat(product.productId, "_").concat(product.productVariation, "_").concat(i),
    productName: product.productName,
    skinId: product.skinId
  }));
};
svs.tickets_giftshop.products.components.CardImageList = CardImageList;

 })(window);